<script>
  import * as _ from 'lodash'
  import Icon from '@shared/svelte/Components/Icon.svelte'
  import Sortable from 'sortablejs';
  import { tick } from 'svelte';

  export let sellSheet;
  export let page;
  page.sortOrder = [];

  function doSort() {
    let nodes = document.getElementById('products-to-sort').childNodes;
    if (!(nodes || []).length > 0) { return }
    _.forEach(nodes,
      function(l) {
        if (_.get(l, 'dataset.key') && l.dataset.key != 'undefined') {
          page.sortOrder.push({id: l.dataset.key})
        }
      }
    )
  }

  async function initSort() {
    await tick()
    var el = document.getElementById('products-to-sort');
    if (el) {
      page.sortObj = Sortable.create(el,
        {
          onSort: function() {
            doSort()
          },
          handle: '.drag-handle'
        }
      );
      return page.sortObj;
    }
  }

  initSort();
</script>


<div class="grid-row padding-bottom--small margin-bottom--small">
  <div class="grid-container" id='products-to-sort'>
    {#each sellSheet.product_lines as productLine}
      <div class="grid-col c12-12 align-left background-white margin-bottom--smaller dpl-row "
        id='product-line-{productLine.id}' data-key={productLine.id} data-id={productLine.id}>
        <div class="grid-row padding--smaller">
          <div class="grid-col c12-12">
            <div class="media">
              <div class="media-fluid align-self-center">
                <div class="default-subheader--bold">{productLine.name}</div>
                {#if productLine.manufacturer}
                  <div class="grid-col c12-12 margin-top--smallest">
                    <span class='s5 margin-top--smallest strong'>
                      Manufacturer:
                    </span>
                    <span class='s5'>
                      {productLine.manufacturer}
                    </span>
                  </div>
                {/if}
                {#if productLine.category}
                  <div class="grid-col c12-12 margin-top--smallest">
                    <span class='s5 margin-top--smallest strong'>
                      Type:
                    </span>
                    <span class='s5'>
                      {productLine.category}
                    </span>
                  </div>
                {/if}
              </div>
              <div class="media-fixed align-right secondary-body--bold">
                <div class="cursor-grab display-inline-block margin-right--smallest margin-top--smaller color-grayDark drag-handle">
                  <Icon
                    width="18"
                    height="18"
                    type="Menu"
                  ></Icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    {/each}
    <div class="grid-row"><hr class="hr hr-card-separator"></div>
  </div>
</div>
